import { z } from 'zod';
import { nonEmptyString } from './common.ts';

// POST /api/support/quick-ticket
export const quickTicketInput = z.object({
  email: z.string().email(),
  subject: nonEmptyString,
  message: nonEmptyString,
});
export type QuickTicketInput = z.infer<typeof quickTicketInput>;

export const quickTicketResponse = z.object({
  ok: z.boolean(),
  data: z.unknown().optional(),
  error: z.string().optional(),
  detail: z.unknown().optional(),
});
export type QuickTicketResponse = z.infer<typeof quickTicketResponse>;

// GET /api/support/health
export const supportHealthResponse = z.object({
  ok: z.boolean(),
  host_status: z.number().optional(),
  api_status: z.number().optional(),
  error: z.union([z.string(), z.number()]).optional(),
});
export type SupportHealthResponse = z.infer<typeof supportHealthResponse>;
